import styled from 'styled-components';

export const StyledIframe = styled.iframe`
  border: 0;
  width: 100%;
  height: 600px;
`;

export const Container = styled.div`
  ol {
    padding-left: 35px;
    line-height: 35px;
  }
`;

export const PreviewButtons = styled.div`
  margin-bottom: 15px;
  margin-left: 15px;
  button {
    margin-right: 15px;
  }
`;
